import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// components
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Checkbox } from 'primereact/checkbox';
// lib
import portfolioService from 'data/portfolio'
import api_match from 'data/interface/api'
// styles
import { Label_s } from 'styles/app-styles'
import DataTable_s from 'components/table/data-table-styles'
import { ReportPropertyGrid_s, SelectAll_s } from "components/folder/reports/report-styles"

interface PortfolioReportGrid {
  onChange: (selected: object[]) => void
}

const ReportPortfolioGrid: FC<PortfolioReportGrid> = (props) => {
  const [portfolios, setPortfolios] = useState<object[]>([])
  const [selected, updateSelected] = useState<object[]>([])

  useEffect(() => {
    const portfolioSubscription = portfolioService.stream().subscribe(data => {
      api_match(
        data,
        init  => setPortfolios(init.value),
        ok    => {
          setPortfolios(ok.value)
        },
        err   => {
          setPortfolios(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    portfolioService.fetchPortfolios()

    return function cleanup(){
      portfolioSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    props.onChange(selected)
  }, [selected])

  return (
    <ReportPropertyGrid_s>
      <Label_s>Selected Portfolios</Label_s>
      <DataTable_s style={{overflowY: 'visible'}}>
        <SelectAll_s>
          <Checkbox onChange={e => e.checked ? updateSelected(portfolios) : updateSelected([])} checked={selected.length === portfolios.length}></Checkbox>
        </SelectAll_s>
        <DataTable
          value={portfolios}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          emptyMessage="No records found"
          selection={selected}
          onSelectionChange={(e) => e.value.length === portfolios.length ? selected.length === portfolios.length ? updateSelected([]) : updateSelected(e.value) : updateSelected(e.value)}
          footer={
            <Label_s style={{ float: 'left', marginTop: '-31px' }}>
              {selected.length} selected portfolios
            </Label_s>
          }>
          <Column selectionMode="multiple" />
          <Column field="code" header="Code" filter={true} sortable={true} style={{width: '150px'}}/>
          <Column field="name" header="Name" filter={true} sortable={true} style={{width: '150px'}}/>
        </DataTable>
      </DataTable_s>
    </ReportPropertyGrid_s>
  )
}

export default ReportPortfolioGrid